"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    setStartDirection = _useStylesUtils.setStartDirection;
  var ccLoginBtnStyle = (0, _react.useMemo)(function () {
    var ccLoginBtnImage = (0, _css.css)({
      height: 'auto',
      top: '50%',
      transform: 'translate(0, -50%)',
      position: 'absolute'
    });
    var ccLoginBtnText = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily,
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      fontSize: pxToRem(20),
      lineHeight: pxToRem(25)
    }, setStartDirection(85)));
    var ccLoginBtn = (0, _css.css)({
      background: '#FAFAFA',
      fontWeight: '600',
      position: 'relative',
      border: "".concat(pxToRem(2), " solid currentColor"),
      borderRadius: pxToRem(8),
      width: '100%',
      display: 'block',
      cursor: 'pointer',
      textAlign: 'start',
      '&:nth-child(1)': _defineProperty({
        color: 'black',
        height: pxToRem(128),
        marginBottom: pxToRem(5)
      }, '.' + ccLoginBtnImage, _objectSpread({
        width: pxToRem(40)
      }, setStartDirection(30))),
      '&:nth-child(2)': _defineProperty({
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
        height: pxToRem(65)
      }, '.' + ccLoginBtnImage, _objectSpread({
        width: pxToRem(40)
      }, setStartDirection(30)))
    });
    return {
      ccLoginBtn: ccLoginBtn,
      ccLoginBtnImage: ccLoginBtnImage,
      ccLoginBtnText: ccLoginBtnText
    };
  }, [fontFamily, themeColors, pxToRem, setStartDirection]);
  return {
    'cc-Login__login-btn': ccLoginBtnStyle.ccLoginBtn,
    'cc-Login__login-btn__image': ccLoginBtnStyle.ccLoginBtnImage,
    'cc-Login__login-btn__text': ccLoginBtnStyle.ccLoginBtnText
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;